export default "__VITE_ASSET__CPAqsvrz__"